// Theme Entry Point - Main TypeScript
// NO CSS IMPORTS - All styles loaded via page-specific entrypoints

// Web Components - Global (used across all pages)
import "@/components/details-disclosure";
import "@/components/details-modal";
import "@/components/cart-notification";
import "@/components/predictive-search";
import "@/components/share-button";

const init = (): void => {
  console.log("[Vite] Theme bundle loaded - Web Components registered");
};

// Run on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
